<template>
  <div
    class="back"
    @click="$emit('onClick')"
  />
</template>

<script>
export default {
  name: 'ProaBackButton'
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";
@import "@/styles/mediaquery";

.back {
  width: 30px;
  height: 30px;
  position: relative;
  cursor: pointer;

  &:before,
  &:after {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    content: "";
  }

  &:before {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background-color: transparent;

    @include mq(md) {
      background-color: $background-color;
    }
  }

  &:after {
    left: 12px;
    width: 12px;
    height: 12px;
    border-top: 2px solid $secondary-color;
    border-right: 2px solid $secondary-color;
    transform: rotate(225deg);

    @include mq(md) {
      width: 8px;
      height: 8px;
    }
  }

  &:hover:before {
    background-color: $light-border-color;
  }
}
</style>
